module.exports = __webpack_public_path__ + "30fb9ecf0bb83bc0be59e9c0b03a57f3.svg";